export const GLOBAL_STATE = 'AchievementRecords'

export const ACHIEVEMENT_RECORDS = 'AchievementRecords'
export const ACHIEVEMENT_RECORDS_CREATE = 'AchievementRecordsCreate'
export const ACHIEVEMENT_RECORDS_ALL = 'AchievementRecordsAll'
export const ACHIEVEMENT_RECORDS_LIST = 'AchievementRecordsList'
export const ACHIEVEMENT_RECORDS_TYPES = 'AchievementRecordsTypes'
export const ACHIEVEMENT_RECORDS_CHANGE_STATUS = 'AchievementRecordsStatus'
export const ACHIEVEMENT_RECORDS_STUDENT = 'AchievementRecordsStudent'
